import styled, { css } from 'styled-components'

export const Fields = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.space['16']};
  `,
)

export const FilePreview = styled.div(
  ({ theme }) => css`
    border: ${theme.border.size['1']} solid ${theme.colors.gray400};
    border-radius: ${theme.border.radius['8']};
    overflow: hidden;

    iframe,
    img {
      display: block;
      width: 100%;
      height: 30rem;
      border: none;
      object-fit: contain;
    }
  `,
)
